export class AttachedCss {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get at() {
        return this.parent;
    }
    get trait() {
        return this.at.trait;
    }
    // @computed.struct
    get cssPairs() {
        let cssKeyPairs = [];
        if (!this.trait.reg) {
            console.log(`Style key ${this.trait.key} ist nicht definiert in registry`);
            return [];
        }
        if (this.trait.reg.css) {
            cssKeyPairs = this.trait.reg.css(this.at.context);
        }
        return cssKeyPairs;
    }
    get styleString() {
        if (!this.trait.reg || !this.trait.reg.style) {
            return '';
        }
        return this.trait.reg.style(this.at.context);
    }
}
